import { markRaw } from 'vue';
import KIWWebform from '../KIWWebform/KIWWebform.vue';
import MultistepSummary from '../MultistepSummary/MultistepSummary.vue';
import SimpleHTML from '../SimpleHTML/SimpleHTML.vue';

export default {
  props: {},

  components: {
    KIWWebform,
  },

  mounted() {},

  data() {
    return {
      cmpLibrary: markRaw({
        MultistepSummary,
        SimpleHTML,
      }),
      defaults: {},
    };
  },

  computed: {},

  methods: {},

  watch: {},
};
